import React from 'react';
import { useHistory } from 'react-router-dom';

type LinkType = 'tab' | 'internal';
interface LinkCellProps {
  text: string;
  url: string;
  type: LinkType;
}

interface FormatLinkProps {
  text: string;
  url: string;
  type: LinkType;
}

const FormatLink: React.FC<FormatLinkProps> = ({ text, url, type }) => {
  const history = useHistory();
  if (type === 'internal') {
    return (
      <span className='' onClick={() => history.push(url)}>
        {text}
      </span>
    );
  }
  return (
    <a href={url} target='_blank' rel='noreferrer'>
      {text}
    </a>
  );
};

const LinkCell: React.FC<LinkCellProps> = (props) => {
  return <td className='link-cell'>{FormatLink(props)}</td>;
};

export default React.memo(LinkCell);
